export const isValidJSON = (text) => {
    try {
        JSON.parse(text);
    } catch (e) {
        return false;
    }
    return true;
};
